var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgItrWave(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 247.56,
    height: 548.676,
    viewBox: "0 0 247.56 548.676",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #000c7a;\r\n      }\r\n\r\n      .cls-2 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n\r\n      .cls-3 {\r\n        clip-path: url(#clip-path-2);\r\n      }\r\n\r\n      .cls-4 {\r\n        clip-path: url(#clip-path-3);\r\n      }\r\n\r\n      .cls-5 {\r\n        clip-path: url(#clip-path-4);\r\n      }\r\n\r\n      .cls-6 {\r\n        clip-path: url(#clip-path-9);\r\n      }\r\n\r\n      .cls-7 {\r\n        clip-path: url(#clip-path-12);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_23916",
    "data-name": "\\uC0AC\\uAC01\\uD615 23916",
    className: "cls-1",
    width: 247.56,
    height: 68.311,
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_23922",
    "data-name": "\\uC0AC\\uAC01\\uD615 23922",
    className: "cls-1",
    width: 247.56,
    height: 68.311
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_23928",
    "data-name": "\\uC0AC\\uAC01\\uD615 23928",
    className: "cls-1",
    width: 247.56,
    height: 69.404,
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_23934",
    "data-name": "\\uC0AC\\uAC01\\uD615 23934",
    className: "cls-1",
    width: 247.56,
    height: 68.858
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_23964",
    "data-name": "\\uC0AC\\uAC01\\uD615 23964",
    className: "cls-1",
    width: 247.56,
    height: 68.858,
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_23982",
    "data-name": "\\uC0AC\\uAC01\\uD615 23982",
    className: "cls-1",
    width: 247.56,
    height: 69.404
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_38796",
    "data-name": "\\uADF8\\uB8F9 38796",
    transform: "translate(-1024.334 502.411)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_104",
    "data-name": "\\uADF8\\uB8F9 104",
    className: "cls-2",
    transform: "translate(1024.334 -502.411)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uB9C8\\uC2A4\\uD06C_\\uADF8\\uB8F9_3-5",
    "data-name": "\\uB9C8\\uC2A4\\uD06C \\uADF8\\uB8F9 3-5",
    transform: "translate(-0.692 21.483)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_16-5",
    "data-name": "\\uADF8\\uB8F9 16-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7845-5",
    "data-name": "\\uD328\\uC2A4 7845-5",
    className: "cls-1",
    d: "M679.078-282.8c-15.757,0-23.745-5.089-31.471-10.012-7.878-5.018-15.317-9.758-30.6-9.758s-22.721,4.74-30.6,9.758c-7.727,4.923-15.716,10.012-31.47,10.012s-23.742-5.089-31.468-10.012c-7.879-5.018-15.316-9.758-30.6-9.758v-1.624c15.757,0,23.742,5.089,31.468,10.012,7.879,5.018,15.316,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.727-4.923,15.716-10.012,31.47-10.012s23.744,5.089,31.471,10.012c7.879,5.018,15.317,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.726-4.923,15.716-10.012,31.471-10.012v1.624c-15.28,0-22.722,4.74-30.6,9.758C702.821-287.887,694.831-282.8,679.078-282.8Z",
    transform: "translate(-492.877 304.192)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7846-5",
    "data-name": "\\uD328\\uC2A4 7846-5",
    className: "cls-1",
    d: "M679.078-278.062c-15.757,0-23.745-5.089-31.471-10.012-7.878-5.018-15.317-9.757-30.6-9.757s-22.721,4.74-30.6,9.757c-7.727,4.923-15.716,10.012-31.47,10.012s-23.742-5.089-31.468-10.012c-7.879-5.018-15.316-9.757-30.6-9.757v-1.624c15.757,0,23.742,5.089,31.468,10.012,7.879,5.018,15.316,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.727-4.923,15.716-10.012,31.47-10.012s23.744,5.089,31.471,10.012c7.879,5.018,15.317,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.726-4.923,15.716-10.012,31.471-10.012v1.624c-15.28,0-22.722,4.74-30.6,9.758C702.821-283.152,694.831-278.062,679.078-278.062Z",
    transform: "translate(-492.877 305.474)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_116",
    "data-name": "\\uADF8\\uB8F9 116",
    className: "cls-3",
    transform: "translate(1024.334 -467.982)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uB9C8\\uC2A4\\uD06C_\\uADF8\\uB8F9_3-11",
    "data-name": "\\uB9C8\\uC2A4\\uD06C \\uADF8\\uB8F9 3-11",
    transform: "translate(-0.692 21.363)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_16-11",
    "data-name": "\\uADF8\\uB8F9 16-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7845-11",
    "data-name": "\\uD328\\uC2A4 7845-11",
    className: "cls-1",
    d: "M679.078-255.8c-15.757,0-23.745-5.089-31.471-10.012-7.878-5.018-15.317-9.758-30.6-9.758s-22.721,4.74-30.6,9.758c-7.727,4.923-15.716,10.012-31.47,10.012s-23.742-5.089-31.468-10.012c-7.879-5.018-15.316-9.758-30.6-9.758v-1.624c15.757,0,23.742,5.089,31.468,10.012,7.879,5.018,15.316,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.727-4.923,15.716-10.012,31.47-10.012s23.744,5.089,31.471,10.012c7.879,5.018,15.317,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.726-4.923,15.716-10.012,31.471-10.012v1.624c-15.28,0-22.722,4.74-30.6,9.758C702.821-260.887,694.831-255.8,679.078-255.8Z",
    transform: "translate(-492.877 277.192)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7846-11",
    "data-name": "\\uD328\\uC2A4 7846-11",
    className: "cls-1",
    d: "M679.078-251.062c-15.757,0-23.745-5.089-31.471-10.012-7.878-5.018-15.317-9.757-30.6-9.757s-22.721,4.74-30.6,9.757c-7.727,4.923-15.716,10.012-31.47,10.012s-23.742-5.089-31.468-10.012c-7.879-5.018-15.316-9.757-30.6-9.757v-1.624c15.757,0,23.742,5.089,31.468,10.012,7.879,5.018,15.316,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.727-4.923,15.716-10.012,31.47-10.012s23.744,5.089,31.471,10.012c7.879,5.018,15.317,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.726-4.923,15.716-10.012,31.471-10.012v1.624c-15.28,0-22.722,4.74-30.6,9.758C702.821-256.152,694.831-251.062,679.078-251.062Z",
    transform: "translate(-492.877 278.474)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_128",
    "data-name": "\\uADF8\\uB8F9 128",
    className: "cls-4",
    transform: "translate(1024.334 -434.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uB9C8\\uC2A4\\uD06C_\\uADF8\\uB8F9_3-17",
    "data-name": "\\uB9C8\\uC2A4\\uD06C \\uADF8\\uB8F9 3-17",
    transform: "translate(-0.692 21.791)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_16-17",
    "data-name": "\\uADF8\\uB8F9 16-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7845-17",
    "data-name": "\\uD328\\uC2A4 7845-17",
    className: "cls-1",
    d: "M679.078-228.8c-15.757,0-23.745-5.089-31.471-10.012-7.878-5.018-15.317-9.758-30.6-9.758s-22.721,4.74-30.6,9.758c-7.727,4.923-15.716,10.012-31.47,10.012s-23.742-5.089-31.468-10.012c-7.879-5.018-15.316-9.758-30.6-9.758v-1.624c15.757,0,23.742,5.089,31.468,10.012,7.879,5.018,15.316,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.727-4.923,15.716-10.012,31.47-10.012s23.744,5.089,31.471,10.012c7.879,5.018,15.317,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.726-4.923,15.716-10.012,31.471-10.012v1.624c-15.28,0-22.722,4.74-30.6,9.758C702.821-233.887,694.831-228.8,679.078-228.8Z",
    transform: "translate(-492.877 250.192)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7846-17",
    "data-name": "\\uD328\\uC2A4 7846-17",
    className: "cls-1",
    d: "M679.078-224.062c-15.757,0-23.745-5.089-31.471-10.012-7.878-5.018-15.317-9.757-30.6-9.757s-22.721,4.74-30.6,9.757c-7.727,4.923-15.716,10.012-31.47,10.012s-23.742-5.089-31.468-10.012c-7.879-5.018-15.316-9.757-30.6-9.757v-1.624c15.757,0,23.742,5.089,31.468,10.012,7.879,5.018,15.316,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.727-4.923,15.716-10.012,31.47-10.012s23.744,5.089,31.471,10.012c7.879,5.018,15.317,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.726-4.923,15.716-10.012,31.471-10.012v1.624c-15.28,0-22.722,4.74-30.6,9.758C702.821-229.152,694.831-224.062,679.078-224.062Z",
    transform: "translate(-492.877 251.474)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_140",
    "data-name": "\\uADF8\\uB8F9 140",
    className: "cls-5",
    transform: "translate(1024.334 -399.671)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uB9C8\\uC2A4\\uD06C_\\uADF8\\uB8F9_3-23",
    "data-name": "\\uB9C8\\uC2A4\\uD06C \\uADF8\\uB8F9 3-23",
    transform: "translate(-0.692 21.671)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_16-23",
    "data-name": "\\uADF8\\uB8F9 16-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7845-23",
    "data-name": "\\uD328\\uC2A4 7845-23",
    className: "cls-1",
    d: "M679.078-201.8c-15.757,0-23.745-5.089-31.471-10.012-7.878-5.018-15.317-9.758-30.6-9.758s-22.721,4.74-30.6,9.758c-7.727,4.923-15.716,10.012-31.47,10.012s-23.742-5.089-31.468-10.012c-7.879-5.018-15.316-9.758-30.6-9.758v-1.624c15.757,0,23.742,5.089,31.468,10.012,7.879,5.018,15.316,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.727-4.923,15.716-10.012,31.47-10.012s23.744,5.089,31.471,10.012c7.879,5.018,15.317,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.726-4.923,15.716-10.012,31.471-10.012v1.624c-15.28,0-22.722,4.74-30.6,9.758C702.821-206.887,694.831-201.8,679.078-201.8Z",
    transform: "translate(-492.877 223.192)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7846-23",
    "data-name": "\\uD328\\uC2A4 7846-23",
    className: "cls-1",
    d: "M679.078-197.062c-15.757,0-23.745-5.089-31.471-10.012-7.878-5.018-15.317-9.757-30.6-9.757s-22.721,4.74-30.6,9.757c-7.727,4.923-15.716,10.012-31.47,10.012s-23.742-5.089-31.468-10.012c-7.879-5.018-15.316-9.757-30.6-9.757v-1.624c15.757,0,23.742,5.089,31.468,10.012,7.879,5.018,15.316,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.727-4.923,15.716-10.012,31.47-10.012s23.744,5.089,31.471,10.012c7.879,5.018,15.317,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.726-4.923,15.716-10.012,31.471-10.012v1.624c-15.28,0-22.722,4.74-30.6,9.758C702.821-202.152,694.831-197.062,679.078-197.062Z",
    transform: "translate(-492.877 224.474)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_152",
    "data-name": "\\uADF8\\uB8F9 152",
    className: "cls-2",
    transform: "translate(1024.334 -364.695)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uB9C8\\uC2A4\\uD06C_\\uADF8\\uB8F9_3-29",
    "data-name": "\\uB9C8\\uC2A4\\uD06C \\uADF8\\uB8F9 3-29",
    transform: "translate(-0.692 21.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_16-29",
    "data-name": "\\uADF8\\uB8F9 16-29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7845-29",
    "data-name": "\\uD328\\uC2A4 7845-29",
    className: "cls-1",
    d: "M679.078-174.8c-15.757,0-23.745-5.089-31.471-10.012-7.878-5.018-15.317-9.758-30.6-9.758s-22.721,4.74-30.6,9.758c-7.727,4.923-15.716,10.012-31.47,10.012s-23.742-5.089-31.468-10.012c-7.879-5.018-15.316-9.758-30.6-9.758v-1.624c15.757,0,23.742,5.089,31.468,10.012,7.879,5.018,15.316,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.727-4.923,15.716-10.012,31.47-10.012s23.744,5.089,31.471,10.012c7.879,5.018,15.317,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.726-4.923,15.716-10.012,31.471-10.012v1.624c-15.28,0-22.722,4.74-30.6,9.758C702.821-179.887,694.831-174.8,679.078-174.8Z",
    transform: "translate(-492.877 196.192)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7846-29",
    "data-name": "\\uD328\\uC2A4 7846-29",
    className: "cls-1",
    d: "M679.078-170.062c-15.757,0-23.745-5.089-31.471-10.012-7.878-5.018-15.317-9.757-30.6-9.757s-22.721,4.74-30.6,9.757c-7.727,4.923-15.716,10.012-31.47,10.012s-23.742-5.089-31.468-10.012c-7.879-5.018-15.316-9.757-30.6-9.757v-1.624c15.757,0,23.742,5.089,31.468,10.012,7.879,5.018,15.316,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.727-4.923,15.716-10.012,31.47-10.012s23.744,5.089,31.471,10.012c7.879,5.018,15.317,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.726-4.923,15.716-10.012,31.471-10.012v1.624c-15.28,0-22.722,4.74-30.6,9.758C702.821-175.152,694.831-170.062,679.078-170.062Z",
    transform: "translate(-492.877 197.474)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_164",
    "data-name": "\\uADF8\\uB8F9 164",
    className: "cls-5",
    transform: "translate(1024.334 -330.813)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uB9C8\\uC2A4\\uD06C_\\uADF8\\uB8F9_3-35",
    "data-name": "\\uB9C8\\uC2A4\\uD06C \\uADF8\\uB8F9 3-35",
    transform: "translate(-0.692 21.433)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_16-35",
    "data-name": "\\uADF8\\uB8F9 16-35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7845-35",
    "data-name": "\\uD328\\uC2A4 7845-35",
    className: "cls-1",
    d: "M679.078-147.8c-15.757,0-23.745-5.089-31.471-10.012-7.878-5.018-15.317-9.758-30.6-9.758s-22.721,4.74-30.6,9.758c-7.727,4.923-15.716,10.012-31.47,10.012s-23.742-5.089-31.468-10.012c-7.879-5.018-15.316-9.758-30.6-9.758v-1.624c15.757,0,23.742,5.089,31.468,10.012,7.879,5.018,15.316,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.727-4.923,15.716-10.012,31.47-10.012s23.744,5.089,31.471,10.012c7.879,5.018,15.317,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.726-4.923,15.716-10.012,31.471-10.012v1.624c-15.28,0-22.722,4.74-30.6,9.758C702.821-152.887,694.831-147.8,679.078-147.8Z",
    transform: "translate(-492.877 169.192)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7846-35",
    "data-name": "\\uD328\\uC2A4 7846-35",
    className: "cls-1",
    d: "M679.078-143.062c-15.757,0-23.745-5.089-31.471-10.012-7.878-5.018-15.317-9.757-30.6-9.757s-22.721,4.74-30.6,9.757c-7.727,4.923-15.716,10.012-31.47,10.012s-23.742-5.089-31.468-10.012c-7.879-5.018-15.316-9.757-30.6-9.757v-1.624c15.757,0,23.742,5.089,31.468,10.012,7.879,5.018,15.316,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.727-4.923,15.716-10.012,31.47-10.012s23.744,5.089,31.471,10.012c7.879,5.018,15.317,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.726-4.923,15.716-10.012,31.471-10.012v1.624c-15.28,0-22.722,4.74-30.6,9.758C702.821-148.152,694.831-143.062,679.078-143.062Z",
    transform: "translate(-492.877 170.474)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_176",
    "data-name": "\\uADF8\\uB8F9 176",
    className: "cls-3",
    transform: "translate(1024.334 -296.384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uB9C8\\uC2A4\\uD06C_\\uADF8\\uB8F9_3-41",
    "data-name": "\\uB9C8\\uC2A4\\uD06C \\uADF8\\uB8F9 3-41",
    transform: "translate(-0.692 21.314)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_16-41",
    "data-name": "\\uADF8\\uB8F9 16-41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7845-41",
    "data-name": "\\uD328\\uC2A4 7845-41",
    className: "cls-1",
    d: "M679.078-120.8c-15.757,0-23.745-5.089-31.471-10.012-7.878-5.018-15.317-9.758-30.6-9.758s-22.721,4.74-30.6,9.758c-7.727,4.923-15.716,10.012-31.47,10.012s-23.742-5.089-31.468-10.012c-7.879-5.018-15.316-9.758-30.6-9.758v-1.624c15.757,0,23.742,5.089,31.468,10.012,7.879,5.018,15.316,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.727-4.923,15.716-10.012,31.47-10.012s23.744,5.089,31.471,10.012c7.879,5.018,15.317,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.726-4.923,15.716-10.012,31.471-10.012v1.624c-15.28,0-22.722,4.74-30.6,9.758C702.821-125.887,694.831-120.8,679.078-120.8Z",
    transform: "translate(-492.877 142.192)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7846-41",
    "data-name": "\\uD328\\uC2A4 7846-41",
    className: "cls-1",
    d: "M679.078-116.062c-15.757,0-23.745-5.089-31.471-10.012-7.878-5.018-15.317-9.757-30.6-9.757s-22.721,4.74-30.6,9.757c-7.727,4.923-15.716,10.012-31.47,10.012s-23.742-5.089-31.468-10.012c-7.879-5.018-15.316-9.757-30.6-9.757v-1.624c15.757,0,23.742,5.089,31.468,10.012,7.879,5.018,15.316,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.727-4.923,15.716-10.012,31.47-10.012s23.744,5.089,31.471,10.012c7.879,5.018,15.317,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.726-4.923,15.716-10.012,31.471-10.012v1.624c-15.28,0-22.722,4.74-30.6,9.758C702.821-121.152,694.831-116.062,679.078-116.062Z",
    transform: "translate(-492.877 143.474)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_188",
    "data-name": "\\uADF8\\uB8F9 188",
    className: "cls-3",
    transform: "translate(1024.334 -261.955)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uB9C8\\uC2A4\\uD06C_\\uADF8\\uB8F9_3-47",
    "data-name": "\\uB9C8\\uC2A4\\uD06C \\uADF8\\uB8F9 3-47",
    transform: "translate(-0.692 21.195)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_16-47",
    "data-name": "\\uADF8\\uB8F9 16-47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7845-47",
    "data-name": "\\uD328\\uC2A4 7845-47",
    className: "cls-1",
    d: "M679.078-93.8c-15.757,0-23.745-5.089-31.471-10.012-7.878-5.018-15.317-9.758-30.6-9.758s-22.721,4.74-30.6,9.758C578.684-98.887,570.7-93.8,554.942-93.8S531.2-98.887,523.474-103.81c-7.879-5.018-15.316-9.758-30.6-9.758v-1.624c15.757,0,23.742,5.089,31.468,10.012,7.879,5.018,15.316,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.727-4.923,15.716-10.012,31.47-10.012s23.744,5.089,31.471,10.012c7.879,5.018,15.317,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.726-4.923,15.716-10.012,31.471-10.012v1.624c-15.28,0-22.722,4.74-30.6,9.758C702.821-98.887,694.831-93.8,679.078-93.8Z",
    transform: "translate(-492.877 115.192)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7846-47",
    "data-name": "\\uD328\\uC2A4 7846-47",
    className: "cls-1",
    d: "M679.078-89.062c-15.757,0-23.745-5.089-31.471-10.012-7.878-5.018-15.317-9.757-30.6-9.757s-22.721,4.74-30.6,9.757c-7.727,4.923-15.716,10.012-31.47,10.012S531.2-94.152,523.474-99.074c-7.879-5.018-15.316-9.757-30.6-9.757v-1.624c15.757,0,23.742,5.089,31.468,10.012,7.879,5.018,15.316,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.727-4.923,15.716-10.012,31.47-10.012s23.744,5.089,31.471,10.012c7.879,5.018,15.317,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.726-4.923,15.716-10.012,31.471-10.012v1.624c-15.28,0-22.722,4.74-30.6,9.758C702.821-94.152,694.831-89.062,679.078-89.062Z",
    transform: "translate(-492.877 116.474)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_200",
    "data-name": "\\uADF8\\uB8F9 200",
    className: "cls-6",
    transform: "translate(1024.334 -228.073)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uB9C8\\uC2A4\\uD06C_\\uADF8\\uB8F9_3-53",
    "data-name": "\\uB9C8\\uC2A4\\uD06C \\uADF8\\uB8F9 3-53",
    transform: "translate(-0.692 21.622)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_16-53",
    "data-name": "\\uADF8\\uB8F9 16-53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7845-53",
    "data-name": "\\uD328\\uC2A4 7845-53",
    className: "cls-1",
    d: "M679.078-66.8c-15.757,0-23.745-5.089-31.471-10.012-7.878-5.018-15.317-9.758-30.6-9.758s-22.721,4.74-30.6,9.758C578.684-71.887,570.7-66.8,554.942-66.8S531.2-71.887,523.474-76.81c-7.879-5.018-15.316-9.758-30.6-9.758v-1.624c15.757,0,23.742,5.089,31.468,10.012,7.879,5.018,15.316,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.727-4.923,15.716-10.012,31.47-10.012S640.752-83.1,648.479-78.18c7.879,5.018,15.317,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.726-4.923,15.716-10.012,31.471-10.012v1.624c-15.28,0-22.722,4.74-30.6,9.758C702.821-71.887,694.831-66.8,679.078-66.8Z",
    transform: "translate(-492.877 88.192)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7846-53",
    "data-name": "\\uD328\\uC2A4 7846-53",
    className: "cls-1",
    d: "M679.078-62.062c-15.757,0-23.745-5.089-31.471-10.012-7.878-5.018-15.317-9.757-30.6-9.757s-22.721,4.74-30.6,9.757c-7.727,4.923-15.716,10.012-31.47,10.012S531.2-67.152,523.474-72.074c-7.879-5.018-15.316-9.757-30.6-9.757v-1.624c15.757,0,23.742,5.089,31.468,10.012,7.879,5.018,15.316,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.727-4.923,15.716-10.012,31.47-10.012s23.744,5.089,31.471,10.012c7.879,5.018,15.317,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.726-4.923,15.716-10.012,31.471-10.012v1.624c-15.28,0-22.722,4.74-30.6,9.758C702.821-67.152,694.831-62.062,679.078-62.062Z",
    transform: "translate(-492.877 89.474)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_212",
    "data-name": "\\uADF8\\uB8F9 212",
    className: "cls-3",
    transform: "translate(1024.334 -193.644)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uB9C8\\uC2A4\\uD06C_\\uADF8\\uB8F9_3-59",
    "data-name": "\\uB9C8\\uC2A4\\uD06C \\uADF8\\uB8F9 3-59",
    transform: "translate(-0.692 21.503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_16-59",
    "data-name": "\\uADF8\\uB8F9 16-59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7845-59",
    "data-name": "\\uD328\\uC2A4 7845-59",
    className: "cls-1",
    d: "M679.078-39.8c-15.757,0-23.745-5.089-31.471-10.012-7.878-5.018-15.317-9.758-30.6-9.758s-22.721,4.74-30.6,9.758C578.684-44.887,570.7-39.8,554.942-39.8S531.2-44.887,523.474-49.81c-7.879-5.018-15.316-9.758-30.6-9.758v-1.624c15.757,0,23.742,5.089,31.468,10.012,7.879,5.018,15.316,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.727-4.923,15.716-10.012,31.47-10.012S640.752-56.1,648.479-51.18c7.879,5.018,15.317,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.726-4.923,15.716-10.012,31.471-10.012v1.624c-15.28,0-22.722,4.74-30.6,9.758C702.821-44.887,694.831-39.8,679.078-39.8Z",
    transform: "translate(-492.877 61.192)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7846-59",
    "data-name": "\\uD328\\uC2A4 7846-59",
    className: "cls-1",
    d: "M679.078-35.062c-15.757,0-23.745-5.089-31.471-10.012-7.878-5.018-15.317-9.757-30.6-9.757s-22.721,4.74-30.6,9.757c-7.727,4.923-15.716,10.012-31.47,10.012S531.2-40.152,523.474-45.074c-7.879-5.018-15.316-9.757-30.6-9.757v-1.624c15.757,0,23.742,5.089,31.468,10.012,7.879,5.018,15.316,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.727-4.923,15.716-10.012,31.47-10.012s23.744,5.089,31.471,10.012c7.879,5.018,15.317,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.726-4.923,15.716-10.012,31.471-10.012v1.624c-15.28,0-22.722,4.74-30.6,9.758C702.821-40.152,694.831-35.062,679.078-35.062Z",
    transform: "translate(-492.877 62.474)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_224",
    "data-name": "\\uADF8\\uB8F9 224",
    className: "cls-6",
    transform: "translate(1024.334 -159.215)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uB9C8\\uC2A4\\uD06C_\\uADF8\\uB8F9_3-65",
    "data-name": "\\uB9C8\\uC2A4\\uD06C \\uADF8\\uB8F9 3-65",
    transform: "translate(-0.692 21.383)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_16-65",
    "data-name": "\\uADF8\\uB8F9 16-65"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7845-65",
    "data-name": "\\uD328\\uC2A4 7845-65",
    className: "cls-1",
    d: "M679.078-12.8c-15.757,0-23.745-5.089-31.471-10.012-7.878-5.018-15.317-9.758-30.6-9.758s-22.721,4.74-30.6,9.758C578.684-17.887,570.7-12.8,554.942-12.8S531.2-17.887,523.474-22.81c-7.879-5.018-15.316-9.758-30.6-9.758v-1.624c15.757,0,23.742,5.089,31.468,10.012,7.879,5.018,15.316,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.727-4.923,15.716-10.012,31.47-10.012S640.752-29.1,648.479-24.18c7.879,5.018,15.317,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.726-4.923,15.716-10.012,31.471-10.012v1.624c-15.28,0-22.722,4.74-30.6,9.758C702.821-17.887,694.831-12.8,679.078-12.8Z",
    transform: "translate(-492.877 34.192)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7846-65",
    "data-name": "\\uD328\\uC2A4 7846-65",
    className: "cls-1",
    d: "M679.078-8.062c-15.757,0-23.745-5.089-31.471-10.012-7.878-5.018-15.317-9.757-30.6-9.757s-22.721,4.74-30.6,9.757c-7.727,4.923-15.716,10.012-31.47,10.012S531.2-13.152,523.474-18.074c-7.879-5.018-15.316-9.757-30.6-9.757v-1.624c15.757,0,23.742,5.089,31.468,10.012,7.879,5.018,15.316,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.727-4.923,15.716-10.012,31.47-10.012s23.744,5.089,31.471,10.012c7.879,5.018,15.317,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.726-4.923,15.716-10.012,31.471-10.012v1.624c-15.28,0-22.722,4.74-30.6,9.758C702.821-13.152,694.831-8.062,679.078-8.062Z",
    transform: "translate(-492.877 35.474)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_236",
    "data-name": "\\uADF8\\uB8F9 236",
    className: "cls-7",
    transform: "translate(1024.334 -125.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uB9C8\\uC2A4\\uD06C_\\uADF8\\uB8F9_3-71",
    "data-name": "\\uB9C8\\uC2A4\\uD06C \\uADF8\\uB8F9 3-71",
    transform: "translate(-0.692 21.811)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_16-71",
    "data-name": "\\uADF8\\uB8F9 16-71",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7845-71",
    "data-name": "\\uD328\\uC2A4 7845-71",
    className: "cls-1",
    d: "M679.078,14.2c-15.757,0-23.745-5.089-31.471-10.012-7.879-5.018-15.317-9.758-30.6-9.758s-22.721,4.74-30.6,9.758C578.684,9.113,570.7,14.2,554.942,14.2S531.2,9.113,523.474,4.19c-7.878-5.018-15.316-9.758-30.6-9.758V-7.192c15.757,0,23.742,5.089,31.468,10.012,7.879,5.018,15.316,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.727-4.923,15.716-10.012,31.47-10.012S640.752-2.1,648.479,2.82c7.879,5.018,15.317,9.758,30.6,9.758s22.721-4.74,30.6-9.758C717.4-2.1,725.392-7.192,741.147-7.192v1.624c-15.28,0-22.722,4.74-30.6,9.758C702.822,9.113,694.831,14.2,679.078,14.2Z",
    transform: "translate(-492.877 7.192)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7846-71",
    "data-name": "\\uD328\\uC2A4 7846-71",
    className: "cls-1",
    d: "M679.078,18.938c-15.757,0-23.745-5.089-31.471-10.012-7.878-5.018-15.317-9.757-30.6-9.757s-22.721,4.74-30.6,9.757c-7.727,4.923-15.716,10.012-31.47,10.012S531.2,13.848,523.474,8.926c-7.879-5.018-15.316-9.757-30.6-9.757V-2.455c15.757,0,23.742,5.089,31.468,10.012,7.879,5.018,15.316,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.727-4.923,15.716-10.012,31.47-10.012s23.744,5.089,31.471,10.012c7.879,5.018,15.317,9.758,30.6,9.758s22.721-4.74,30.6-9.758C717.4,2.634,725.392-2.455,741.147-2.455V-.831c-15.28,0-22.722,4.74-30.6,9.758C702.821,13.848,694.831,18.938,679.078,18.938Z",
    transform: "translate(-492.877 8.474)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_248",
    "data-name": "\\uADF8\\uB8F9 248",
    className: "cls-2",
    transform: "translate(1024.334 -90.357)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uB9C8\\uC2A4\\uD06C_\\uADF8\\uB8F9_3-77",
    "data-name": "\\uB9C8\\uC2A4\\uD06C \\uADF8\\uB8F9 3-77",
    transform: "translate(-0.692 21.145)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_16-77",
    "data-name": "\\uADF8\\uB8F9 16-77"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7845-77",
    "data-name": "\\uD328\\uC2A4 7845-77",
    className: "cls-1",
    d: "M679.078,41.2c-15.757,0-23.745-5.089-31.471-10.012-7.878-5.018-15.317-9.758-30.6-9.758s-22.721,4.74-30.6,9.758C578.684,36.113,570.7,41.2,554.942,41.2S531.2,36.113,523.474,31.19c-7.879-5.018-15.316-9.758-30.6-9.758V19.808c15.757,0,23.742,5.089,31.468,10.012,7.879,5.018,15.316,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.727-4.923,15.716-10.012,31.47-10.012S640.752,24.9,648.479,29.82c7.879,5.018,15.317,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.726-4.923,15.716-10.012,31.471-10.012v1.624c-15.28,0-22.722,4.74-30.6,9.758C702.821,36.113,694.831,41.2,679.078,41.2Z",
    transform: "translate(-492.877 -19.808)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7846-77",
    "data-name": "\\uD328\\uC2A4 7846-77",
    className: "cls-1",
    d: "M679.078,45.938c-15.757,0-23.745-5.089-31.471-10.012-7.878-5.018-15.317-9.757-30.6-9.757s-22.721,4.74-30.6,9.757c-7.727,4.923-15.716,10.012-31.47,10.012S531.2,40.848,523.474,35.926c-7.879-5.018-15.316-9.757-30.6-9.757V24.545c15.757,0,23.742,5.089,31.468,10.012,7.879,5.018,15.316,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.727-4.923,15.716-10.012,31.47-10.012s23.744,5.089,31.471,10.012c7.879,5.018,15.317,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.726-4.923,15.716-10.012,31.471-10.012v1.624c-15.28,0-22.722,4.74-30.6,9.758C702.821,40.848,694.831,45.938,679.078,45.938Z",
    transform: "translate(-492.877 -18.526)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_260",
    "data-name": "\\uADF8\\uB8F9 260",
    className: "cls-2",
    transform: "translate(1024.334 -55.928)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uB9C8\\uC2A4\\uD06C_\\uADF8\\uB8F9_3-83",
    "data-name": "\\uB9C8\\uC2A4\\uD06C \\uADF8\\uB8F9 3-83",
    transform: "translate(-0.692 21.026)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_16-83",
    "data-name": "\\uADF8\\uB8F9 16-83"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7845-83",
    "data-name": "\\uD328\\uC2A4 7845-83",
    className: "cls-1",
    d: "M679.078,68.2c-15.757,0-23.745-5.089-31.471-10.012-7.878-5.018-15.317-9.758-30.6-9.758s-22.721,4.74-30.6,9.758C578.684,63.113,570.7,68.2,554.942,68.2S531.2,63.113,523.474,58.19c-7.879-5.018-15.316-9.758-30.6-9.758V46.808c15.757,0,23.742,5.089,31.468,10.012,7.879,5.018,15.316,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.727-4.923,15.716-10.012,31.47-10.012S640.752,51.9,648.479,56.82c7.879,5.018,15.317,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.726-4.923,15.716-10.012,31.471-10.012v1.624c-15.28,0-22.722,4.74-30.6,9.758C702.821,63.113,694.831,68.2,679.078,68.2Z",
    transform: "translate(-492.877 -46.808)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7846-83",
    "data-name": "\\uD328\\uC2A4 7846-83",
    className: "cls-1",
    d: "M679.078,72.938c-15.757,0-23.745-5.089-31.471-10.012-7.878-5.018-15.317-9.757-30.6-9.757s-22.721,4.74-30.6,9.757c-7.727,4.923-15.716,10.012-31.47,10.012S531.2,67.848,523.474,62.926c-7.879-5.018-15.316-9.757-30.6-9.757V51.545c15.757,0,23.742,5.089,31.468,10.012,7.879,5.018,15.316,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.727-4.923,15.716-10.012,31.47-10.012s23.744,5.089,31.471,10.012c7.879,5.018,15.317,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.726-4.923,15.716-10.012,31.471-10.012v1.624c-15.28,0-22.722,4.74-30.6,9.758C702.821,67.848,694.831,72.938,679.078,72.938Z",
    transform: "translate(-492.877 -45.526)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_272",
    "data-name": "\\uADF8\\uB8F9 272",
    className: "cls-2",
    transform: "translate(1024.334 -22.046)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uB9C8\\uC2A4\\uD06C_\\uADF8\\uB8F9_3-89",
    "data-name": "\\uB9C8\\uC2A4\\uD06C \\uADF8\\uB8F9 3-89",
    transform: "translate(-0.692 21.453)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_16-89",
    "data-name": "\\uADF8\\uB8F9 16-89"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7845-89",
    "data-name": "\\uD328\\uC2A4 7845-89",
    className: "cls-1",
    d: "M679.078,95.2c-15.757,0-23.745-5.089-31.471-10.012-7.878-5.018-15.317-9.758-30.6-9.758s-22.721,4.74-30.6,9.758C578.684,90.113,570.7,95.2,554.942,95.2S531.2,90.113,523.474,85.19c-7.879-5.018-15.316-9.758-30.6-9.758V73.808c15.757,0,23.742,5.089,31.468,10.012,7.879,5.018,15.316,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.727-4.923,15.716-10.012,31.47-10.012S640.752,78.9,648.479,83.82c7.879,5.018,15.317,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.726-4.923,15.716-10.012,31.471-10.012v1.624c-15.28,0-22.722,4.74-30.6,9.758C702.821,90.113,694.831,95.2,679.078,95.2Z",
    transform: "translate(-492.877 -73.808)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7846-89",
    "data-name": "\\uD328\\uC2A4 7846-89",
    className: "cls-1",
    d: "M679.078,99.938c-15.757,0-23.745-5.089-31.471-10.012-7.878-5.018-15.317-9.757-30.6-9.757s-22.721,4.74-30.6,9.757c-7.727,4.923-15.716,10.012-31.47,10.012S531.2,94.848,523.474,89.926c-7.879-5.018-15.316-9.757-30.6-9.757V78.545c15.757,0,23.742,5.089,31.468,10.012,7.879,5.018,15.316,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.727-4.923,15.716-10.012,31.47-10.012s23.744,5.089,31.471,10.012c7.879,5.018,15.317,9.758,30.6,9.758s22.721-4.74,30.6-9.758c7.726-4.923,15.716-10.012,31.471-10.012v1.624c-15.28,0-22.722,4.74-30.6,9.758C702.821,94.848,694.831,99.938,679.078,99.938Z",
    transform: "translate(-492.877 -72.526)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItrWave);
export default __webpack_public_path__ + "static/media/itr-wave.b32ef5cae349f626028ee6d65d97852b.svg";
export { ForwardRef as ReactComponent };